import Head from 'next/head';
import 'animate.css';
import preview from '../../public/preview/preview-design.png';
import { Footer, Header } from '../../components';
import DesignPage from './design-page';
import menu from '../../utils/menu';

export default function Design() {
  return (
    <>
      <Head>
        <title>
          Mavinx Design Services: Elevating Brands with Creative and Impactful
          Solutions
        </title>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700;800&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;300;400;500;600;700;800;900&display=swap"
          rel="stylesheet"
        />
        <meta
          property="og:title"
          content="Mavinx Design Services: Elevating Brands with Creative and Impactful Solutions"
        />
        <meta property="og:image" content={`${preview.src}`} />
        <meta name="twitter:image" content={`${preview.src}`} />
        <meta
          property="og:image:alt"
          content="Mavinx Design Services: Elevating Brands with Creative and Impactful Solutions"
        />
        <meta property="og:type" content="product" />
        <meta
          property="og:description"
          content="Mavinx elevates companies through unique and compelling design services. Explore our graphic design, UI/UX design, brand identity, and visual storytelling expertise that captivates and lasts. Learn how our design team works with customers to understand their vision, values, and target audience and create beautiful, user-centric designs. Mavinx creates engaging logos, websites, marketing materials, and digital assets."
        />
        <meta
          name="description"
          content="Mavinx elevates companies through unique and compelling design services. Explore our graphic design, UI/UX design, brand identity, and visual storytelling expertise that captivates and lasts. Learn how our design team works with customers to understand their vision, values, and target audience and create beautiful, user-centric designs. Mavinx creates engaging logos, websites, marketing materials, and digital assets."
        />
        <meta
          name="keywords"
          content="Mavinx team, meet the team, passionate experts, innovation, success, web developers, mobile app developers, designers, marketers, project managers, collaborative approach, customer-centric, commitment to excellence, skills, dedication, top-quality deliverables, customer satisfaction, collaboration, expertise, business goals"
        />
      </Head>
      <Header appearance="transparent" appearanceLogo="primary" menu={menu} />
      <DesignPage />
      <Footer />
    </>
  );
}
